import { graphql, useStaticQuery } from "gatsby";
import HeroSection from "../../components/Sections/HeroSection";

const ReferHeroBlock = () => {
  const data = useStaticQuery(graphql`
    query ReferHomeQuery {
      allDataJson {
        edges {
          node {
            Refer {
              HeroBlock {
                reverse
                heading {
                  text
                  color
                }
                backgroundColor
              }
            }
          }
        }
      }
      hero: file(relativePath: { eq: "refer/hero.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1500, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      logo: file(relativePath: { eq: "refer/BusinessReferal.png" }) {
        childImageSharp {
          gatsbyImageData(width: 250, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
    }
  `);

  const { HeroBlock } = data.allDataJson.edges[0].node.Refer;

  return (
    <HeroSection
      alignCenter
      position="bottom"
      heroWidth={"60%"}
      imageMarginTop
      imagePosition={{
        bottom: [0, null, 0, -100],
        // left: -100,
      }}
      contentWidth={"43%"}
      imageMaxWidth={950}
      {...HeroBlock}
      heroImage={data.hero.childImageSharp.gatsbyImageData}
      logo={data.logo.childImageSharp.gatsbyImageData}
    />
  );
};

export default ReferHeroBlock;
